import DefaultAvatar from '../../assets/images/avatar.png';
import { stringToColor } from '../../utils/common.util';
interface AvatarProps {
  size: '2xs' | 'sm' | 'base' | 'lg' | 'xs';
  url: string;
  alt: string;
  contain?: boolean;
  bg?: 'white' | 'black';
  variant?: 'rounded' | 'squircle';
}

const avatarSize = {
  '2xs': 30,
  xs: 40,
  sm: 50,
  base: 80,
  lg: 100,
};

const BG_COLOR = {
  white: 'white',
  black: 'black',
};

export default function Avatar(props: AvatarProps) {
  const { size, url, alt, contain, bg } = props;
  const itemSize = avatarSize[size];
  const bgColor = url.length
    ? BG_COLOR[bg || 'white']
    : stringToColor(alt || 'default');

  const rounding =
    props.variant === 'rounded' ? 'rounded-full' : 'mask mask-squircle';

  return (
    <img
      alt={alt}
      src={url || DefaultAvatar}
      className={`${contain ? 'object-contain' : 'object-cover'} ${rounding}`}
      style={{
        height: itemSize,
        width: itemSize,
        backgroundColor: bgColor,
      }}
    />
  );
}
